<template>
  <div id="knowledgeNewEdit" class="pb-8">
    <vs-row>
      <vs-col vs-lg="8" vs-sm="8" vs-xs="12">
        <section class="w-full select-knowledge justify-center items-center mt-5">
          <div class="mb-5">
            <div class="flex mb-2">
              <small class="align-self-center small">Título do Modelo</small>
            </div>

            <div class="w-full">
              <vs-input
                  v-model="description"
                  class="w-full"
                  maxlength="255"
                  name="description"
                  v-validate="'required'"
              />

              <div class="w-full params-wrapper mt-5" v-if="description">
                <span class="text-sm text-left">Caracteres: {{description.length}}/255</span>
              </div>

              <vs-alert color="danger" icon="new_releases" active="true" class="mt-3 text-sm" v-show="errors.has('description')">
                <p>O campo título é obrigatório.</p>
              </vs-alert>
            </div>
          </div>

          <div class="mt-5 justify-content-center">
            <vs-row>
              <vs-col vs-w="6">
                <div class="switchers">
                  <div class="flex mb-2">
                    <small class="align-self-center small">Exibir Campo de Observação?</small>
                  </div>

                  <div class="item w-full mt-1 flex">
                    <vs-switch v-model="useObservation">
                      <span slot="on">Sim</span>
                      <span slot="off">Não</span>
                    </vs-switch>
                  </div>
                </div>
              </vs-col>

              <vs-col vs-w="6" v-if="useObservation">
                <div class="switchers">
                  <div class="flex mb-2">
                    <small class="align-self-center small">Observação Obrigatória?</small>
                  </div>
                  <div class="item w-full mt-1 flex">
                    <vs-switch v-model="requireObservation">
                      <span slot="on">Sim</span>
                      <span slot="off">Não</span>
                    </vs-switch>
                  </div>
                </div>
              </vs-col>
            </vs-row>
          </div>
        </section>

        <section>
          <div class="mt-10 text-center">
            <h6>OPÇÕES</h6>
            <small v-if="options.length === 0">Nenhuma opção cadastrada</small>
          </div>

          <component
            :index="index"
            @onRemoveReasonOption="removeOption"
            :list="knowledgeOptionsAttributes[index]"
            v-for="(option, index) in options"
            :key="index"
            :is="option"
            class="body mt-5"
          />

          <vs-button
            type="flat"
            @click.prevent="addOption"
          >
            Adicionar Opção
          </vs-button>
        </section>

        <div class="w-full d-flex justify-content-flex-end">
          <vs-button @click.prevent="create">Salvar</vs-button>
        </div>
      </vs-col>

      <vs-col vs-lg="4" vs-sm="4" vs-xs="0" style="display: block;">
        <div style="position: sticky; top: 0; padding-top: 15px">
          <reasons-preview :use_observation="useObservation" :reason_options="knowledgeOptionsAttributes"></reasons-preview>
        </div>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
  import requests from '@/http/requests/reasons'
  import ReasonOptionForm from '@/views/reason-options/Form'
  import ReasonsPreview from "@/components/reasons/ReasonsPreview.vue";
  import { formatRouteTenantPath } from '@/utils'
  import { knowledgeType } from "@/supports/reasonSupport";

  export default {
    name: 'knowledge-new',
    components: { ReasonOptionForm, ReasonsPreview },
    provide() {
      return { $validator: this.$validator }
    },
    data() {
      return {
        options: [],
        knowledgeOptionsAttributes: [],
        description: '',
        useObservation: false,
        requireObservation: false,
      }
    },
    created () {},
    methods: {
      addOption() {
        this.knowledgeOptionsAttributes.push({
          description: '',
          is_required: false,
          number: this.options.length,
          reason_option_items_attributes: []
        })
        
        this.options.push(ReasonOptionForm);
      },
      removeOption(idx) {
        this.knowledgeOptionsAttributes.splice(idx, 1)
        this.options.splice(idx, 1)
      },
      create() {
        this.$validator.validateAll().then((valid) => {
          if (!valid) { return }
          let dataToPost = this.knowledgeOptionsAttributes

          dataToPost.map((item) => {
            delete item["reason_option_kind"]
            return item
          });

          let args = {
            type: knowledgeType,
            description: this.description,
            use_observation: this.useObservation,
            require_observation: this.requireObservation,
            reason_options_attributes: dataToPost,
          }

          requests.create(args).then(() => {
            this.$router.push(formatRouteTenantPath('/knowledge/list'))
            this.$vs.notify({
              color: 'success',
              title: 'Sucesso!',
              text: 'O Modelo foi criado com sucesso'
            })
          });
        }).catch((error) => { console.error(error) })
      }
    },
  }
</script>

<style lang="scss">
  #knowledgeNewEdit {
    .select-knowledge {
      padding: 15px;
      background: #fff;
      border-radius:10px;
      text-align:center;
      flex-direction: column;
      border: 1px solid rgba(0, 0, 0, 0.2);
    }

    .switchers{
      display: inline-grid;
      .item{
        justify-content: center;
      }
    }

    .body {
      border: none;
      padding: 10px; 
      background: #fff;
      border-radius: 10px;
      box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.090);
    }
  }
</style>